import StaticLayout from 'common/Layout/StaticLayout';
import { Text } from 'common/styles';
import { __t } from 'common/i18n';
import StaticText from 'common/StaticText';
import Seo from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';

export default function Rules() {
  return <>
    <Seo
      title={`${__t('static_siteName')} | ${__t('static.rules.title')}`}
      description="قوانین و مقررات استفاده از سرویس‌های فیلمنت شامل حریم خصوصی، شرایط اشتراک، حقوق کاربران و ضوابط محتوا را اینجا مطالعه کنید."
      path="/rules"
    />
    <Breadcrumb items={[
      { name: __t('common.home'), url: '/' },
      { name: __t('static.rules.title'), url: '/rules' },
    ]} />
    <StaticLayout cover="/static/images/static_pages/rules_cover_img.jpg" title={__t('static.rules.title')}>
      <Text variant="h2" mb={1}>{__t('static.rules.privay.title')}</Text>
      <StaticText>{__t('static.rules.privay.desc')}</StaticText>

      <Text variant="h2" mb={1} mt={6}>{__t('static.rules.services.title')}</Text>
      <StaticText>{__t('static.rules.services.desc')}</StaticText>

      <Text variant="h2" mb={1} mt={6}>{__t('static.rules.account.title')}</Text>
      <StaticText>{__t('static.rules.account.desc')}</StaticText>
    </StaticLayout>
  </>;
}
